
    <template>
      <section class="content example-md-doc">
        <anchor is-edit label="隐藏表头" fileName="base.md" />
        <demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
    &lt;div&gt;
        &lt;el-radio-group v-model=&quot;showHeaderRadio&quot;&gt;
            &lt;el-radio label=&quot;Show&quot;&gt;Show&lt;/el-radio&gt;
            &lt;el-radio label=&quot;Hidden&quot;&gt;Hidden&lt;/el-radio&gt;
        &lt;/el-radio-group&gt;
        &lt;br /&gt;
        &lt;br /&gt;
        &lt;ve-table :show-header=&quot;showHeader&quot; :columns=&quot;columns&quot; :table-data=&quot;tableData&quot; /&gt;
    &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
    export default {
        data() {
            return {
                showHeaderRadio: &quot;Hidden&quot;,
                columns: [
                    { field: &quot;col1&quot;, key: &quot;col1&quot;, title: &quot;Col1&quot; },
                    { field: &quot;col2&quot;, key: &quot;col2&quot;, title: &quot;Col2&quot; },
                    { field: &quot;col3&quot;, key: &quot;col3&quot;, title: &quot;Col3&quot; },
                    { field: &quot;col4&quot;, key: &quot;col4&quot;, title: &quot;Col4&quot; },
                    { field: &quot;col5&quot;, key: &quot;col5&quot;, title: &quot;Col5&quot; },
                    { field: &quot;col6&quot;, key: &quot;col6&quot;, title: &quot;Col6&quot; },
                ],
                tableData: [],
            };
        },
        computed: {
            showHeader() {
                return this.showHeaderRadio === &quot;Show&quot;;
            },
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i &lt; 8; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
        null
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',[_c('el-radio-group',{model:{value:(_vm.showHeaderRadio),callback:function ($$v) {_vm.showHeaderRadio=$$v},expression:"showHeaderRadio"}},[_c('el-radio',{attrs:{"label":"Show"}},[_vm._v("Show")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"Hidden"}},[_vm._v("Hidden")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('ve-table',{attrs:{"show-header":_vm.showHeader,"columns":_vm.columns,"table-data":_vm.tableData}})],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
        data() {
            return {
                showHeaderRadio: "Hidden",
                columns: [
                    { field: "col1", key: "col1", title: "Col1" },
                    { field: "col2", key: "col2", title: "Col2" },
                    { field: "col3", key: "col3", title: "Col3" },
                    { field: "col4", key: "col4", title: "Col4" },
                    { field: "col5", key: "col5", title: "Col5" },
                    { field: "col6", key: "col6", title: "Col6" },
                ],
                tableData: [],
            };
        },
        computed: {
            showHeader() {
                return this.showHeaderRadio === "Show";
            },
        },
        methods: {
            initTableData() {
                let data = [];
                for (let i = 0; i < 8; i++) {
                    data.push({
                        rowKey: i,
                        col1: `A${i + 1}`,
                        col2: `B${i + 1}`,
                        col3: `C${i + 1}`,
                        col4: `D${i + 1}`,
                        col5: `E${i + 1}`,
                        col6: `F${i + 1}`,
                        col7: `G${i + 1}`,
                        col8: `H${i + 1}`,
                    });
                }
                this.tableData = data;
            },
        },
        created() {
            this.initTableData();
        },
    };
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
    <style lang="less">
      
    </style>
  